import {useEffect, useState} from "react";
import {subscribe} from "./PusherClient";
import {useGetMainBranch} from "../../store/api/AuthSlice";
import {arrivedFromV2, forgetArrival, isHandoffToV2Enabled, redirectToDispatchV2} from "../../utils/BranchHandoff";

/** Redirects to dispatch v2 when the current branch has automation enabled. */
const useAutomationWebsocket = (): void => {

    const mainBranch = useGetMainBranch()
    const branchId = mainBranch?.iikoId ?? ""
    const [live, setLive] = useState<{ branchId: string, enabled: boolean } | null>(null)
    const enabled = isHandoffToV2Enabled()

    useEffect(() => {
        // Handoff is off: nothing to listen for.
        if (!branchId || !enabled) return

        const prefix = process.env.REACT_APP_PUSHER_ORGANIZATION_CHANNEL_PREFIX || "organization"
        const event = process.env.REACT_APP_PUSHER_ORGANIZATION_EVENT_NAME
            || "OrganizationEnableAutoAssignmentEvent"

        return subscribe(`${prefix}.${branchId}`, event, (data: any) => {
            // Payload may be wrapped in `data`.
            const frame = data && typeof data.isAutomationEnabled === "boolean" ? data : data?.data
            if (!frame || typeof frame.isAutomationEnabled !== "boolean") return
            // Ignore events for a previous branch.
            if (frame.iikoId !== branchId) return

            setLive({branchId, enabled: frame.isAutomationEnabled})
        })
    }, [branchId, enabled]);

    // Socket value is newer than the branch list, so it wins.
    const known = mainBranch?.isAutomationEnabled
    const confirmed = live?.branchId === branchId ? live.enabled : known
    const automated = confirmed ?? false

    useEffect(() => {
        if (!branchId || !enabled) return

        if (!automated) {
            // Reset the loop guard only when the flag is really false, not still loading.
            if (confirmed === false && arrivedFromV2(branchId)) forgetArrival()
            return
        }

        // v2 just sent us here: redirecting back would loop.
        if (arrivedFromV2(branchId)) {
            console.warn(`Automation handoff loop for branch ${branchId}`)
            return
        }

        if (!redirectToDispatchV2(branchId)) {
            console.warn("REACT_APP_DISPATCH_V2_URL is not configured")
        }
    }, [branchId, automated, confirmed, enabled]);
}

export default useAutomationWebsocket
